<template>
  <section class="container">
    <el-form label-width="100px">
      <el-form-item label="标题">
        <!-- <el-input v-model="editObject.brand_title"/> -->
        <span v-text="editObject.brand_title" />
      </el-form-item>
      <el-form-item label="英文标题">
        <!-- <el-input v-model="editObject.brand_title"/> -->
        <span v-text="editObject.brand_english_title" />
      </el-form-item>
      <el-form-item label="跳转链接">
        <!-- <el-input v-model="editObject.brand_url"/> -->
        <span v-text="editObject.brand_url" />
      </el-form-item>
      <el-form-item label="所属风格">
        <!-- <el-input v-model="editObject.style_title"/> -->
        <span v-text="editObject.style_title" />
      </el-form-item>
      <el-form-item label="图片">
        <img
          v-if="editObject.brand_img"
          :src="qiniuDomain + editObject.brand_img"
          class="avatar">
      </el-form-item>
      <el-form-item label="banner">
        <div
          v-if="editObject.brand_banner"
          class="banner-box">
          <img
            :src="qiniuDomain + editObject.brand_banner"
            class="banner-img" >
        </div>
      </el-form-item>
      <el-form-item label="副文本">
        <!-- <el-input v-model="editObject.brand_content"/> -->
        <div v-html="editObject.brand_content" />
      </el-form-item>
      <el-form-item label="英文副文本">
        <!-- <el-input v-model="editObject.brand_content"/> -->
        <div v-html="editObject.brand_english_content" />
      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  brandDetail,
} from '@/api/style'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      editObject: { //  根据接口来的命名，不是很喜欢---
        brand_title: '',
        brand_img: '',
        style_uuid: '',
        brand_url: '',
        brand_content: '',
        brand_file: '',
        brand_banner: '',
        //  编辑时用
        style_title: '',
        brand_english_content: '',
      },
    };
  },

  created() {
    this.network().getQiniuInfo()
    this.network().brandDetail()
  },
  methods: {
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        brandDetail: async () => {
          const { status, data } = await brandDetail({
            uuid: this.$route.params.uuid,
          })
          if (status === 200) {
            this.editObject = data
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
   .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/style/brand-detail.vue